// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1Qd2A","list":"styles_list__13sHe"};